/**
 * Check if any of the three previous years' values match the end value
 * This is used to determine if a trend classification should be treated as an exception
 */
export default (val2014, val2015, val2016, endValue2) => val2014 === endValue2 || val2015 === endValue2 || val2016 === endValue2;
